import _ from 'lodash';
import { connect } from 'react-redux';
import waterfall from 'async/waterfall';

import * as listsRedux from '../../common/redux/modules/lists';
import * as authUserGmsRedux from '../../common/redux/modules/authUser/generalManagers';
import * as gvaRedux from '../../common/redux/modules/collections/gameVenueAssessment';
import * as teamRedux from '../../common/redux/modules/collections/team';
import * as gameRedux from '../../common/redux/modules/collections/game';
import * as locationRedux from '../../common/redux/modules/collections/location';
import * as locationSupplementRedux from '../../common/redux/modules/collections/locationSupplement';
import * as venueRedux from '../../common/redux/modules/collections/venue';
import * as venueToTeamMappingRedux from '../../common/redux/modules/collections/venueToTeamMapping';
import * as gameVenueStatusRedux from '../../common/redux/modules/collections/gameVenueStatus';
import { showModal, hideModal } from "../../common/redux/modal";

function mapStateToProps(state, ownProps) {
	const { gameId, } = ownProps;
	let { venueId, awayTeamId, homeTeamId } = ownProps;
	const extractedGameProps = {};

	if (!venueId) {
		const game = _.get(state, ['collections', 'game', gameId]);
		if (game) {
			venueId = extractedGameProps.venueId = game.venueId;
			awayTeamId = extractedGameProps.awayTeamId = game.awayTeamId;
			homeTeamId = extractedGameProps.homeTeamId = game.homeTeamId;
			extractedGameProps.sportId = game.sportId;
		}
	}

	const authUser = _.get(state, ['authUser', 'user']);
	const venue = _.get(state, ['collections', 'venue', venueId]);
	const awayTeam = _.get(state, ['collections', 'team', awayTeamId]);
	const homeTeam = _.get(state, ['collections', 'team', homeTeamId]);

	const gameVenueAssessmentIds = _.get(state.lists, ['gameVenueAssessmentIdsForGame', gameId]);

	let assessment;
	if (gameVenueAssessmentIds) {
		const gameVenueAssessments = _.compact(gameVenueAssessmentIds.map((id) => {
			return state.collections.gameVenueAssessment[id];
		}));

		const match = _.find(gameVenueAssessments, {creatorUserId : authUser.userId, venueId : venueId, gameId : gameId});
		assessment = (match) ? match.assessmentValue : 'unsure';
	}

	const gameVenueStatus = _.get(state, ['collections', 'gameVenueStatus', gameId]);

	let location, locationSupplement;
	if (venue) {
		const locationId = venue.locationId;
		location = state.collections.location[locationId];
		locationSupplement = state.collections.locationSupplement[locationId];
	}

	return {
		authUser,
		venue,
		gameVenueStatus,
		authUserGeneralManagers : state.authUser.generalManagers,
		assessment,
		location,
		locationSupplement,
		awayTeam,
		homeTeam,
		...extractedGameProps,
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { gameId } = ownProps;

	return {
		//+ gets
		getGameVenueStatus : () => dispatch(gameVenueStatusRedux.get({gameIds : [gameId]})),
		getAuthUserGeneralManagers : () => dispatch(authUserGmsRedux.getGeneralManagers()),
		getAuthUserAssessment : () => dispatch(listsRedux.search({list: 'gameVenueAssessmentIdsForGame', listId: gameId})),
		getTeams : teamIds => dispatch(teamRedux.get({teamIds})),
		getVenue : venueId => dispatch(venueRedux.get({
			venueIds : [venueId]
		})),
		getLocation : (locationId) => dispatch(locationRedux.get({locationIds : [locationId]})),
		getLocationSupplement : (locationId) => dispatch(locationSupplementRedux.get({locationIds : [locationId]})),
		//+ sets
		addGameVenueAssessment : (params, callback) => dispatch(gvaRedux.addGameVenueAssessment(params, callback)),
		setNewVenue : (params, callback) => dispatch(gameRedux.update(_.assignIn({gameId : gameId}, params), callback)),
		createVenue : (params, callback) => {
			dispatch((dispatch, getState) => {
				waterfall([
					callback => locationRedux.add(params, callback)(dispatch, getState),
					(r, callback) => {
						params.locationId = _.get(r, ['locationIds', '0']);
						venueRedux.add(params, callback)(dispatch, getState);
					},
					(r, callback) => {
						params.venueId = _.get(r, ['venueIds', '0']);
						venueToTeamMappingRedux.add(params, callback)(dispatch, getState);
					},
					(r, callback) => gameRedux.update({
						gameId,
						venueId: params.venueId
					}, callback)(dispatch, getState),
					(r, callback) => {
						// uh, hacky but submit a YES assessment for it now
						// NOTE: XXX its the new assessment!
						gvaRedux.addGameVenueAssessment({
							venueId: params.venueId,
							gameId,
							assessmentValue: 'confirm'
						}, callback)(dispatch, getState);
					},
				], callback);
			});
		},
		modifyVenue : (venueId, params, callback) => {
			dispatch((dispatch, getState) => {
				waterfall([
					(callback) => {
						locationRedux.update(params, callback)(dispatch, getState);
					},
					(r, callback) => {
						venueRedux.update(params, callback)(dispatch, getState);
					},
					(r, callback) => {
						// uh,, hacky but submit a YES assessment for it now
						gvaRedux.addGameVenueAssessment({
							venueId : venueId,
							gameId : gameId,
							assessmentValue : 'confirm'
						}, callback)(dispatch, getState);
					},
				], callback);
			});
		},
		showGameVenueManagementPopup: (gameId) => dispatch(showModal({
			modalType: 'GAME_VENUE_MANAGEMENT',
			contentProps: {
				gameId,
			},
			modalProps: {
				title: 'Fix this game venue',
			}
		})),
		hideModal: () => dispatch(hideModal()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps);
